import { PagedList } from "./pagination";

export class Organization {
    id: number;
    name: string;
    code: string;
    parentOrganizationId: number;
    isParentOrganization: boolean;
    isPatientOrganization: boolean;
}

export class PagedOrganizationGridDto {
    apiEnabledOrganizations: PagedList<Organization>;
    notificationSignatureInProgress: boolean;
    isOriginatorUser: boolean;
}